import { addItemsToMuscle } from "./index7.js";
import { getCapturedDistances } from "./index127.js";
import { AggUnitsOnMuscleNMCS } from "./index166.js";
import { getFirstDoorDistances } from "./index167.js";
import { GetAllBones, getDefaultMix } from "@project-rouge/rg-core";
const AggBuildingFromAnatomyNmcs = ({ building, aggZoneProps, dataset, weights }) => {
	const distribution = aggZoneProps.unitMix || getDefaultMix(dataset);
	const bones = GetAllBones(building.data.anatomy);
	for (const bone of bones) {
		const muscles = bone.muscles.slice().sort((a, b) => (a.skipCores ? 0 : 1) - (b.skipCores ? 0 : 1));
		for (const muscle of muscles) {
			const { flatsAndCores, onGFChildren } = AggUnitsOnMuscleNMCS({
				dataset,
				muscle,
				distribution,
				weights,
				endClosingDistances: getCapturedDistances(muscle),
				endEntranceDistances: getFirstDoorDistances(muscle)
			});
			addItemsToMuscle(building, muscle, flatsAndCores, onGFChildren);
		}
	}
	return { building };
};
export { AggBuildingFromAnatomyNmcs };

//# sourceMappingURL=index168.js.map